import React, { FC } from "react";
import { NewsArticleDoctorCard } from "./NewsArticleDoctorCard";
import { NewsArticleContainerDoctor } from "../DoctorsContainer/NewsArticleContainerDoctor.csharp";

interface DoctorsContainerListProps {
  doctors: NewsArticleContainerDoctor[];
}

export const NewsArticleDoctorsContainer: FC<DoctorsContainerListProps> = ({
  doctors,
}) => {
  return (
    <div className="mb-4 mb-lg-5 offset-lg-up">
      {doctors.map((doctor) => (
        <div className="row edge-to-edge-sm col-sm-12 col-md-9 d-md-flex mb-1">
          <div key={doctor.id}>
            <NewsArticleDoctorCard {...doctor} />
          </div>
        </div>
      ))}
    </div>
  );
};
